import request from '@/service/lib/request'

/**
 * 测报灯 - 更新图片识别
 * @param {String} url 请求地址
 * @param {Object} params 请求参数
 */
export function update(id, data) {
  return request({
    url: `/api/v2/pictures/${id}/review`,
    method: 'put',
    data
  })
}

export function recognize(key, image) {
  return request({
    url: `/api/v2/devices/${key}/recognize`,
    method: 'post',
    data: { image }
  })
}
